import { Button } from "@dune/ui";
import { Plus } from "@untitled-ui/icons-react";
import React from "react";

interface DashboardHeaderProps {
	firstName: string;
	onNewProject: () => void;
	isNewProject?: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
	firstName,
	onNewProject,
	isNewProject = true,
}) => {
	return (
		<div className="flex items-center justify-between">
			<h1 className="text-3xl font-semibold text-text-main-blue">
				Bonjour {firstName}
			</h1>
			{isNewProject && (
				<Button onClick={onNewProject} className="gap-2">
					<Plus className="h-4 w-4" />
					Nouveau projet
				</Button>
			)}
		</div>
	);
};
